import React from 'react';
import NavbarSettings from './NavbarSettings';
import {Link} from 'react-router-dom';
import NavbarProfile from './NavbarProfile';
import NavBarNotification from './NavBarNotification';
import NavBarActionableTrades from './NavBarActionableTrades';
import NavBarPendingOffers from './NavBarPendingOffers';
import NavBarSteamAccountSelect from './NavBarSteamAccountSelect';
import NavbarIconMobile from './NavbarIconMobile';
import NavBarAdminActionableTrades from "./NavBarAdminActionableTrades";
import NavBarAdminActionableTransaction from "./NavBarAdminActionableTransaction";

const NavbarMobile = () => {
    return (
        <nav
            className="block lg:hidden fixed top-0 left-0 right-0 transition-all duration-300 z-50 bg-neutral-100 dark:bg-dark border-b border-neutral-200 dark:border-neutral-700 h-[65px]"
        >
            <div className="flex justify-between px-4 mt-3">
                <Link to="/" className="flex">
                    <NavbarIconMobile/>
                </Link>
                <div className="flex space-x-2 items-center">
                    <NavBarAdminActionableTransaction/>
                    <NavBarAdminActionableTrades/>
                    <NavBarPendingOffers/>
                    <NavBarActionableTrades/>
                    <NavBarSteamAccountSelect/>
                    <NavbarProfile/>
                    <NavBarNotification/>
                    <NavbarSettings/>
                </div>
            </div>
        </nav>
    );
};

export default NavbarMobile;